import {
  globalConstants,
  processedMarketingAttributionReduxConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const {
  GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA,
  GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA,
} = processedMarketingAttributionReduxConstants;

const initialState = {
  processedMarketingAttributionReportGraphData: [],
  processedMarketingAttributionReportPaginatedData: [],
  processedMarketingAttributionReportPagination: {
    pageSize: 10,
    totalElements: 0,
    pageNumber: 0,
  },
};

export const processedMarketingAttributionReportReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA + SUCCESS:
      return {
        ...state,
        processedMarketingAttributionReportPaginatedData: action.data?.data,
        processedMarketingAttributionReportPagination: action.data?.page,
      };

    case GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA + SUCCESS:
      return {
        ...state,
        processedMarketingAttributionReportGraphData: action.data?.result,
      };

    default:
      return state;
  }
};
